<template>
  <div class="teen-page teen10">
    <div class="header">
      <h1>青花瓷：中国瓷器的瑰宝</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_10.png" alt="青花瓷">
        <div class="caption">青花瓷，中国瓷器艺术的巅峰之作</div>
      </div>

      <h2>一、 青花瓷的历史</h2>
      <p>青花瓷是中国传统瓷器中的珍品。它起源于唐代，成熟于元代，鼎盛于明清时期。青花瓷以钴蓝为颜料，在白色瓷胎上绘制图案，然后罩上一层透明釉，经高温烧制而成。</p>

      <h2>二、 制作工艺</h2>
      <p>青花瓷的制作工艺复杂，包括制胎、绘画、上釉、烧制等多个环节。画师需要在湿润的瓷胎上熟练地绘制图案，然后经过高温烧制，才能呈现出鲜艳的蓝色花纹。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_10.png" alt="青花瓷制作">
        <div class="caption">青花瓷制作过程，传统手工艺的传承</div>
      </div>

      <h2>三、 艺术特色</h2>
      <p>青花瓷的图案题材丰富，包括山水、人物、花鸟、吉祥图案等。青花瓷的蓝色清新淡雅，具有独特的艺术魅力。它不仅是实用的器皿，更是精美的艺术品。</p>

      <h2>四、 文化意义</h2>
      <p>青花瓷是中国文化的重要象征，它通过丝绸之路传播到世界各地，成为中外文化交流的重要载体。青花瓷的制作技艺体现了中国古代工匠的智慧和创造力。</p>

      <div class="quote-box">
        "白釉青花一火成，花从釉里透分明。" —— 清代诗人
      </div>

      <h2>五、 传承与创新</h2>
      <p>如今，青花瓷制作技艺得到了很好的传承和发展。现代工匠在继承传统工艺的基础上，不断创新，创作出更多精美的青花瓷作品，让这门古老的艺术焕发新的生机。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen10'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #f5f5f0;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #1e3a5f;
  border-bottom: 2px solid #4a90c2;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 10px;
}

.quote-box {
  background: #e3f2fd;
  padding: 20px;
  border-left: 4px solid #1e3a5f;
  margin: 25px 0;
  font-style: italic;
  color: #333;
}
</style>